import axiosClient from './axiosClient';
import createFormData from './formData';

const normalizeOptionalNumber = (value) => {
  if (value === '' || value === null || value === undefined) {
    return null;
  }

  return value;
};

const normalizeBoolean = (value) => {
  return value ? 1 : 0;
};

const normalizeProductPayload = (payload = {}) => {
  const pricingType = payload.pricing_type || 'fixed';

  return {
    ...payload,
    category_id: payload.category_id || null,
    pricing_type: pricingType,
    base_price: pricingType === 'sizes' ? null : payload.base_price,
    discount_price:
      pricingType === 'sizes'
        ? null
        : normalizeOptionalNumber(payload.discount_price),
    is_featured: normalizeBoolean(payload.is_featured),
    allow_supplements: normalizeBoolean(payload.allow_supplements),
    sort_order: payload.sort_order || 0,
    regenerate_slug: normalizeBoolean(payload.regenerate_slug),
    sizes: Array.isArray(payload.sizes) ? payload.sizes : [],
    supplements: Array.isArray(payload.supplements)
      ? payload.supplements
      : [],
    images: Array.isArray(payload.images) ? payload.images : [],
  };
};

const normalizeSupplementPayload = (payload = {}) => {
  return {
    ...payload,
    price: payload.price || 0,
    sort_order: payload.sort_order || 0,
    is_active: normalizeBoolean(payload.is_active),
  };
};

export const productsApi = {
  getProducts(establishmentId, params = {}) {
    return axiosClient.get(
      `/establishments/${establishmentId}/products`,
      {
        params,
      },
    );
  },

  getActiveProducts(establishmentId, params = {}) {
    return axiosClient.get(
      `/establishments/${establishmentId}/products`,
      {
        params: {
          is_active: 1,
          per_page: 100,
          ...params,
        },
      },
    );
  },

  getProductsByCategory(establishmentId, categoryId, params = {}) {
    return axiosClient.get(
      `/establishments/${establishmentId}/products`,
      {
        params: {
          category_id: categoryId,
          per_page: 100,
          ...params,
        },
      },
    );
  },

  getProduct(productId) {
    return axiosClient.get(`/products/${productId}`);
  },

  createProduct(establishmentId, payload) {
    const formData = createFormData(
      normalizeProductPayload(payload),
    );

    return axiosClient.post(
      `/establishments/${establishmentId}/products`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
  },

  updateProduct(productId, payload) {
    const formData = createFormData({
      ...normalizeProductPayload(payload),
      _method: 'PUT',
    });

    return axiosClient.post(`/products/${productId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  updateAvailability(productId, status) {
    return axiosClient.patch(`/products/${productId}/availability`, {
      status,
    });
  },

  deleteProduct(productId) {
    return axiosClient.delete(`/products/${productId}`);
  },

  deleteProductImage(imageId) {
    return axiosClient.delete(`/product-images/${imageId}`);
  },

  getSupplements(establishmentId, params = {}) {
    return axiosClient.get(
      `/establishments/${establishmentId}/product-supplements`,
      {
        params,
      },
    );
  },

  getActiveSupplements(establishmentId, params = {}) {
    return axiosClient.get(
      `/establishments/${establishmentId}/product-supplements`,
      {
        params: {
          is_active: 1,
          per_page: 100,
          ...params,
        },
      },
    );
  },

  getSupplement(supplementId) {
    return axiosClient.get(`/product-supplements/${supplementId}`);
  },

  createSupplement(establishmentId, payload) {
    const formData = createFormData(
      normalizeSupplementPayload(payload),
    );

    return axiosClient.post(
      `/establishments/${establishmentId}/product-supplements`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
  },

  updateSupplement(supplementId, payload) {
    const formData = createFormData({
      ...normalizeSupplementPayload(payload),
      _method: 'PUT',
    });

    return axiosClient.post(
      `/product-supplements/${supplementId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
  },

  deleteSupplement(supplementId) {
    return axiosClient.delete(`/product-supplements/${supplementId}`);
  },
};

export default productsApi;